<template>
  <div class="center">
    <div class="container">
      <el-row :gutter="20" style="width: 100%;">
        <el-col :span="24">
          <div class="titlepanel">
            晚归/未归人员统计{{checkinDate}}
            <el-button style="float:right;padding-top: auto">
              <router-link :to="{ path: '/sggk'}">返回</router-link>
            </el-button>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="xqul" v-if="housekeeperCapmusHouseDiv">
            <el-select v-model="param.houseId" placeholder="校区/宿舍" @change="changeSchoolCapmusHouse" >
              <el-option v-for="(item,index) in campusHouseList" :key="index" :label="item.houseName" :data-campusId="item.schoolNum" :value="item.houseId" ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="xqul" v-if="adminCapmusDiv">
            <ul>
              <li :class="classObject(999)" :model="param.campusId" @click="campusClick" style="height:auto;line-height:50px;margin-top: 10px;margin-left:5px;width:auto;font-size: 13px;padding-left: 10px;padding-right: 10px;">
                全部
              </li>
              <li v-for="(item,index) in schoolarealist" :key="item.schoolNum" :label="item.schoolName" :value="item.schoolNum" :class="classObject(index)" style="height:auto;line-height:50px;margin-top: 10px;margin-left:5px;width:auto;font-size: 13px;padding-left: 10px;padding-right: 10px;" v-model="param.campusId" @click="campusClick(item,index)">
                {{item.schoolName}}
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="eacharts">
            <div class="bars" style="height: auto">
              <!--<div ref="myEchartBar" style="height:700px;width:100%;padding-top:5px;overflow:auto;" class="myEchartBar"></div>-->
              <div id="myEchartBarDiv"></div>
            </div>
            <div class="bars">
              <!--<div ref="myEchartPie" id="myEchartPieDiv" style="height:700px;width:100%;padding-top:30px" class="myEchartPie" ></div>-->
              <div id="myEchartPieDiv" style="height:700px;width:100%;padding-top:30px"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import Api from '@/api';
  import { session } from '@/util';

  export default {

    data() {
      return {
        schoolarealist: [],
        schoolBackStatistics:{
          checkin_total:'',
          not_back_total:'',
          late_back_total:'',
          name:''
        },
        schoolBackStatisticList:[],
        bardataCurrCampusAllHouseBackStatis:[],
        legenddataCurrCampusAllHouseBackStatis:[],
        width: '100%',
        height: '500px',
        chart: null,
        campusId:'',
        isActive: 999,
        param: {
          campusId: '',
          houseId:'',
        },
        nameList:[],
        noBackList: [],
        lateBackList: [],
        checkinDate:'',
        campusHouseList:[],
        userInfo:'',
        housekeeperCapmusHouseDiv:false,
        adminCapmusDiv:false
      };

    },
    watch: {

    },
    methods: {
      classObject(index) {
        if(this.isActive == index) {
          return "active";
        } else {
          return "";
        }
      },
      drawBarSchoolBackStatistics(schoolBackStatistics) {
        // 基于准备好的dom，初始化echarts实例
        var myEchartDiv =  document.getElementById("myEchartBarDiv");
        var barDiv = document.createElement("div");
        barDiv.style.height = "700px";
        myEchartDiv.appendChild(barDiv);
        var itemTop = 0;
        //this.chart = this.$echarts.init(this.$refs.myEchartBar);
        var myBarchart = this.$echarts.init(barDiv);
        // 绘制图表
        myBarchart.setOption({
          title: {
            text:'总人数：'+schoolBackStatistics.checkin_total,
            subtext: '',
            x: 'center',
            y:'bottom'
          },
          //tooltip: {
          //	trigger: 'item',
          //	formatter: "{a} <br/>{b} : {c} ({d}%)"
          //},
          legend: {
            orient: 'vertical',
            x: 'right',
            y:'bottom',
            data: ['未归人数', '晚归人数']
          },
          toolbox: {
            show: false,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['pie', 'funnel'],
                option: {
                  funnel: {
                    x: '25%',
                    width: '50%',
                    funnelAlign: 'left',
                    max: 1548
                  }
                }
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: false
              }
            }
          },
          calculable: true,
          series: [{
            name: '归宿统计',
            type: 'pie',
            minAngle:.1,  /*最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互*/
            radius: '70%',//圆的大小
            center: ['50%', '50%'],//圆的位置
            data: [{
              value: schoolBackStatistics.checkin_total == 0 || schoolBackStatistics.not_back_total == 0 ? 0 :schoolBackStatistics.not_back_total/*this.keepTwoDecimal((schoolBackStatistics.not_back_total/schoolBackStatistics.checkin_total) * 100)*/,
              name: '未归人数',
              point:schoolBackStatistics.checkin_total == 0 || schoolBackStatistics.not_back_total == 0 ? "" :this.keepTwoDecimal((schoolBackStatistics.not_back_total/schoolBackStatistics.checkin_total) * 100) +"%"+"\n"+schoolBackStatistics.not_back_total+"人\n\n\n\n\n\n\n",
            },
              {
                value: schoolBackStatistics.checkin_total == 0 || schoolBackStatistics.late_back_total == 0 ? 0 :schoolBackStatistics.late_back_total/*this.keepTwoDecimal((schoolBackStatistics.late_back_total/schoolBackStatistics.checkin_total) * 100)*/,
                name: '晚归人数',
                point:schoolBackStatistics.checkin_total == 0 || schoolBackStatistics.late_back_total == 0 ? "" :this.keepTwoDecimal((schoolBackStatistics.late_back_total/schoolBackStatistics.checkin_total) * 100) +"%"+"\n"+schoolBackStatistics.late_back_total+"人",
              },{
                value: schoolBackStatistics.checkin_total == 0 ? 100 : (schoolBackStatistics.not_back_total == schoolBackStatistics.checkin_total || schoolBackStatistics.checkin_total == schoolBackStatistics.late_back_total ? 0 : schoolBackStatistics.checkin_total-schoolBackStatistics.late_back_total-schoolBackStatistics.not_back_total) ,
                name: '总人数',
                //point:"总人数"+schoolBackStatistics.checkin_total+"人",
                point:""
              }
            ],
            itemStyle:{
              normal: {
                label: {        //此处为指示线文字
                  show: true,
                  position: 'inner', //标签的位置
                  textStyle: {
                    fontWeight: 200,
                    fontSize: 14,    //文字的字体大小
                    color: '#FFFFFF',
                    //align: 'center',
                    paddingTop: itemTop
                  },
                  formatter: function (p) {   //指示线对应文字
                    var data = p.data.point;
                    return data;
                  }
                },
                /*labelLine: {    //指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                }*/
              }
            }
          }],
          color: ['#FFB324','#00CDCD','#c4c4c4']//块的颜色
        });
        //myBarchart.resize();//直接加这句即可
      },
      drawBarCurrCampusAllHouseBackStatis() {
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(this.$refs.myEchartBar);
        this.chart.clear();
        // 绘制图表
        this.chart.setOption({
          title: {
            text: '',
            subtext: '',
            x: 'center',
            y: 'bottom'
          },
          /*tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}:占比{d}%"
          },*/
          legend: {
            orient: 'vertical',
            x: 'right',
            y: 'bottom',
            data: ['未归人数', '晚归人数']
          },
          toolbox: {
            show: false,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['pie', 'funnel'],
                option: {
                  funnel: {
                    x: '25%',
                    width: '50%',
                    funnelAlign: 'left',
                    max: 1548
                  }
                }
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: false
              }
            }
          },
          calculable: true,
          series: this.bardataCurrCampusAllHouseBackStatis,
          color: [ '#FFB324','#00CDCD','#b0b0b0'] //块的颜色
        }, true);
        this.chart.resize();//直接加这句即可
      },
      drawPie()
      {
        var myEchartPieDiv = document.getElementById("myEchartPieDiv");
        //用于使chart自适应高度和宽度,通过窗体高宽计算容器高宽
        var resizeWorldMapContainer = function () {
          myEchartPieDiv.style.width = window.innerWidth+'px';
          myEchartPieDiv.style.height = window.innerHeight+'px';
        };
        this.chart = this.$echarts.init(myEchartPieDiv);
        this.chart.clear();
        this.chart.setOption({
          title : {
            text: '',
            subtext: ''
          },
          grid:{
            top:"50px",
            left:"50px",
            right:"15px",
            bottom:"50px"
          },
          tooltip : {
            trigger: 'axis'
          },
          legend: {
            data:['未归人数','晚归人数']
          },
          toolbox: {
            show : false,
            feature : {
              mark : {show: true},
              dataView : {show: false, readOnly: false},
              magicType : {show: true, type: ['line', 'bar']},
              restore : {show: false},
              saveAsImage : {show: false}
            }
          },
          calculable : true,
          color: ['#FFB324','#00CDCD','#F5F5F5'],//块的颜色，
          xAxis : [
            {
              type : 'category',
              ////data : ['男宿舍1栋','男宿舍2栋','男宿舍3栋','男宿舍4栋','男宿舍5栋','男宿舍6栋','生宿舍7栋','男宿舍8栋','男宿舍9栋','男宿舍10栋','男宿舍11栋']
              data:this.nameList,
              name:'宿舍楼栋',
              axisLabel:{
                interval:0,//横轴信息全部显示
                rotate:45,//-30度角倾斜显示
              }
            }
          ],
          yAxis : [
            {
              type : 'value',
              name:'人数',   //这里是纵轴标题
              minInterval : 1
            }
          ],
          boundaryGap : [ 0, 0.1 ],
          series : [
            {
              name:'未归人数',
              type:'bar',
              barWidth : 8,//柱图宽度
              //data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6,20,21],
              data:this.noBackList,
            },
            {
              name:'晚归人数',
              type:'bar',
              barWidth : 8,//柱图宽度
              //data:[2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7,15,17],
              data:this.lateBackList,
            }
          ]
        });
        //用于使chart自适应高度和宽度
        /*window.onresize = function () {
          //重置容器高宽
          resizeWorldMapContainer();
          this.chart.resize();
        };*/
      },
      getSchoolarealist() {
        return new Promise(function(resolve, reject){
          Api.summary.querySchoolCapmus().then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      campusClick(item,index){
        var myEchartBarDiv =  document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        this.nameList = [];
        this.noBackList = [];
        this.lateBackList = [];
        this.drawPie();
        if(item.schoolNum != undefined && item.schoolNum != 'undefined'){
          this.campusId = item.schoolNum;
          this.isActive = index;
          this.bardataCurrCampusAllHouseBackStatis = [];
          this.legenddataCurrCampusAllHouseBackStatis = [];
          this.geCurrCampusAllHouseBackStatisList(item.schoolNum);
          //this.drawPie();////选择校区后的楼栋柱状图
          //this.drawBarCurrCampusAllHouseBackStatis();/////选择校区后的楼栋饼图

        }else{
          this.campusId = '';
          this.isActive = 999;
          let campusBackStatisticsPromise = this.getCampusBackStatistics("classId");
          campusBackStatisticsPromise.then(campusBackStatisticsRes=>{
            if(campusBackStatisticsRes.code==0 && campusBackStatisticsRes.data != null)
          {
            this.schoolBackStatistics =campusBackStatisticsRes.data;
            this.drawBarSchoolBackStatistics(this.schoolBackStatistics);
          }
        })

          let schoolBackStatisticListPromise = this.getAllCapmusAllHouseBackStatisticList();
          schoolBackStatisticListPromise.then(schoolBackStatisticListRes=>{
            if(schoolBackStatisticListRes.code==0 && schoolBackStatisticListRes.data != null && schoolBackStatisticListRes.data.length > 0)
          {
            this.schoolBackStatisticList =schoolBackStatisticListRes.data;
            this.backStatisConvert(this.schoolBackStatisticList);
            this.drawPie();
          }
        })
        }
      },
      changeSchoolCapmusHouse(val){
        for(let i = 0;i < this.campusHouseList.length; i++){
          let house = this.campusHouseList[i];
          if(house.houseId == val){
            this.campusId = house.schoolNum;
            break;
          }
        }
        var myEchartBarDiv =  document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        this.nameList = [];
        this.noBackList = [];
        this.lateBackList = [];
        this.drawPie();
        let getCurrHouseCurrAllFloorBackStatisticListPromise = this.getCurrHouseCurrAllFloorBackStatisticList(val,this.campusId);
        getCurrHouseCurrAllFloorBackStatisticListPromise.then(getCurrHouseCurrAllFloorBackStatisticListRes=>{
          if(getCurrHouseCurrAllFloorBackStatisticListRes.code==0 && getCurrHouseCurrAllFloorBackStatisticListRes.data != null )
        {
          this.schoolBackStatisticList =getCurrHouseCurrAllFloorBackStatisticListRes.data;
          this.backStatisConvert(this.schoolBackStatisticList);
          this.drawPie();
          //this.drawBarCurrCampusAllHouseBackStatis();/////选择校区后的楼栋饼图
          //this.divMoreBar(this.schoolBackStatisticList)
        }
      })

        let getCurrCampusCurrHouseBackStatisticPromise = this.getCurrCampusCurrHouseBackStatistic(val,this.campusId);
        getCurrCampusCurrHouseBackStatisticPromise.then(getCurrCampusCurrHouseBackStatisticRes=>{
          if(getCurrCampusCurrHouseBackStatisticRes.code == 0 && getCurrCampusCurrHouseBackStatisticRes.data != null && getCurrCampusCurrHouseBackStatisticRes.data.length > 0){
          //this.backStatisConvert(this.schoolBackStatisticList);
          this.drawBarSchoolBackStatistics(getCurrCampusCurrHouseBackStatisticRes.data[0]);
        }
      })

      },
      getCampusBackStatistics(str){
        return new Promise(function(resolve, reject){
          Api.summary.getCampusBackStatistics(str).then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      getAllCapmusAllHouseBackStatisticList(){
        return new Promise(function(resolve, reject){
          Api.summary.getAllCapmusAllHouseBackStatisticList().then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      geCurrCampusAllHouseBackStatisListPromise(campusId){
        return new Promise(function(resolve, reject){
          Api.summary.geCurrCampusAllHouseBackStatisList(campusId).then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      getCurrCampusCurrHouseBackStatistic(houseId,campusId){
        return new Promise(function(resolve, reject){
          Api.summary.getCurrCampusCurrHouseBackStatistic(houseId,campusId).then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      getCurrHouseCurrAllFloorBackStatisticList(houseId,campusId){
        return new Promise(function(resolve, reject){
          Api.summary.getCurrHouseCurrAllFloorBackStatisticList(houseId,campusId).then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      queryHouseByManagerUser(){
        return new Promise(function(resolve, reject){
          Api.summary.queryHouseByManagerUser().then(res=>{
            if(res.code==0)
          {
            resolve(res);
          }else
          {
            reject(res);
          }
        })
        })
      },
      geCurrCampusAllHouseBackStatisList(campusId){
        this.nameList = [];
        this.noBackList = [];
        this.lateBackList = [];
        this.bardataCurrCampusAllHouseBackStatis = [];
        this.legenddataCurrCampusAllHouseBackStatis = [];
        var myEchartBarDiv =  document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        let schoolBackStatisticListPromise = this.geCurrCampusAllHouseBackStatisListPromise(campusId);
        schoolBackStatisticListPromise.then(schoolBackStatisticListRes=>{
          if(schoolBackStatisticListRes.code==0 && schoolBackStatisticListRes.data != null && schoolBackStatisticListRes.data.length > 0)
        {
          this.schoolBackStatisticList =schoolBackStatisticListRes.data;
          this.backStatisConvert(this.schoolBackStatisticList);
          this.drawPie();
          //this.drawBarCurrCampusAllHouseBackStatis();/////选择校区后的楼栋饼图
          this.divMoreBar(this.schoolBackStatisticList);
        }
      })
      },
      backStatisConvert(bardata){
        this.nameList = [];
        this.noBackList = [];
        this.lateBackList = [];
        for(let item of bardata){
          if(item){
            this.nameList.push(item.name);
            this.noBackList.push(item.not_back_total);
            this.lateBackList.push(item.late_back_total);
          }
        }
      },
      divMoreBar(bardata){
        var size = bardata.length;
        var radiusSize = 75;
        var centerX = 48;
        var centerY = 50;
        var divHeight = "700px";
        var divWidth = "100%";

        if(size == 2){
          divWidth = "45%";
        }
        if(size == 3){
          divHeight = "400px";
          divWidth = "370px";
        }
        if(size > 3){
          divHeight = "300px";
          divWidth = "270px";
        }
        /*if(size >5){
          radiusSize = 30;
          centerX = 25;
          centerY = 50;
        }
        if(size > 8){
          radiusSize = 30;
        }*/
        let itemIndex = 0;
        let addNum = 0;
        var myEchartBarDiv =  document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        for(let item of bardata){
          if(item){
            //itemIndex++;
            //centerX = centerX + addX
            ////多画布
            var barDiv = document.createElement("div");
            barDiv.style.height = divHeight
            barDiv.style.width = divWidth
            barDiv.style.cssFloat = "left";
            barDiv.style.marginLeft = "20px";
            //barDiv.setAttribute("class","barDiv");
            myEchartBarDiv.appendChild(barDiv);
            var myBarchart = this.$echarts.init(barDiv);
            // 绘制图表
            myBarchart.setOption({
              title: {
                text:item.name+"\n"+"总人数："+item.checkin_total,
                subtext: '',
                x: 'center',
                y:'bottom'
              },
              /*tooltip: {
              	trigger: 'item',
              	formatter: "{a} <br/>{b} : {c} ({d}%)"
              },*/
              /*legend: {
                orient: 'vertical',
                x: 'right',
                y:'bottom',
                data: ['未归人数', '晚归人数']
              },*/
              toolbox: {
                show: false,
                feature: {
                  mark: {
                    show: true
                  },
                  dataView: {
                    show: true,
                    readOnly: false
                  },
                  magicType: {
                    show: true,
                    type: ['pie', 'funnel'],
                    option: {
                      funnel: {
                        x: '25%',
                        width: '50%',
                        funnelAlign: 'left',
                        max: 1548
                      }
                    }
                  },
                  restore: {
                    show: true
                  },
                  saveAsImage: {
                    show: false
                  }
                }
              },
              calculable: true,
              series: [{
                name: '归宿统计',
                type: 'pie',
                //minAngle:.1,  /*最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互*/
                radius: radiusSize+'%',//圆的大小
                center : [centerX+'%', centerY+'%'],//圆的位置
                data: [{
                  value: item.checkin_total == 0 || item.not_back_total == 0 ? 0 : (item.not_back_total == item.checkin_total ? 100 :item.not_back_total/*this.keepTwoDecimal((item.not_back_total/item.checkin_total) * 100)*/),
                  name: '未归人数',
                  point:item.checkin_total == 0 || item.not_back_total == 0 ? "" :this.keepTwoDecimal((item.not_back_total/item.checkin_total) * 100) +"%"+"\n"+item.not_back_total+"人\n\n\n\n\n\n\n",
                },
                  {
                    value: item.checkin_total == 0 || item.late_back_total == 0 ? 0 : (item.checkin_total == item.late_back_total ? 100 :item.late_back_total/*this.keepTwoDecimal((item.late_back_total/item.checkin_total) * 100)*/),
                    name: '晚归人数',
                    point:item.checkin_total == 0 || item.late_back_total == 0 ? "" :this.keepTwoDecimal((item.late_back_total/item.checkin_total) * 100) +"%"+"\n"+item.late_back_total+"人",
                  },{
                    value: item.checkin_total == 0 ? 100 : (item.not_back_total == item.checkin_total || item.checkin_total == item.late_back_total ? 0 : item.checkin_total-item.late_back_total-item.not_back_total) ,
                    name: '总人数',
                    //point:"总人数"+item.checkin_total+"人",
                    point:""
                  }
                ],
                itemStyle:{
                  normal: {
                    label: {        //此处为指示线文字
                      show: true,
                      position: 'inner', //标签的位置
                      textStyle: {
                        fontWeight: 50,
                        fontSize: 12,    //文字的字体大小
                        borderWidth:0,
                        color: '#FFFFFF',
                        align: 'right',
                      },
                      formatter: function (p) {   //指示线对应文字
                        var data = p.data.point;
                        return data;
                      }
                    }
                    /*labelLine: {    //指示线状态
                      show: true,
                      smooth: 0.2,
                      length: 10,
                      length2: 20
                    }*/
                  }
                }
              },
              ],
              color: ['#FFB324','#00CDCD','#c4c4c4']//块的颜色
            });
          }
        }
        var bothDiv = document.createElement("div");
        bothDiv.style.clear = "both";
        myEchartBarDiv.appendChild(bothDiv);
      },
      keepTwoDecimal(num) {
        var result = parseFloat(num);
        if (isNaN(result)) {
          console.log('传递参数错误，请检查！');
        }
        result = Math.round(num * 100) / 100;
        return result;
      }
    },
    mounted() {
      //this.drawBar(this.bardata);
      //this.drawPie(this.bardata);

      let user = session('user');
      let roleName = '';
      let tsr = user.tsr;
      if(tsr != null){
        roleName = tsr.roleName;
      }

      //roleName = "学校管理员";
      //roleName = "宿舍管理员";
      if(roleName != null && (roleName == "学校管理员" || roleName == "后勤管理员")) {
        this.housekeeperCapmusHouseDiv = false
        this.adminCapmusDiv = true
        let campusBackStatisticsPromise = this.getCampusBackStatistics("classId");
        campusBackStatisticsPromise.then(campusBackStatisticsRes=>{
          if(campusBackStatisticsRes.code==0 && campusBackStatisticsRes.data != null)
        {
          this.schoolBackStatistics =campusBackStatisticsRes.data;
          this.checkinDate = this.schoolBackStatistics.checkinDate;
          this.drawBarSchoolBackStatistics(this.schoolBackStatistics);
        }
      })
        let schoolBackStatisticListPromise = this.getAllCapmusAllHouseBackStatisticList();
        schoolBackStatisticListPromise.then(schoolBackStatisticListRes=>{
          if(schoolBackStatisticListRes.code==0 && schoolBackStatisticListRes.data != null && schoolBackStatisticListRes.data.length > 0)
        {
          this.schoolBackStatisticList =schoolBackStatisticListRes.data;
          this.checkinDate = this.schoolBackStatisticList[0].checkinDate
          this.backStatisConvert(this.schoolBackStatisticList);
          this.drawPie();
        }
      })
      }else if(roleName != null && roleName == "宿舍管理员"){
        this.housekeeperCapmusHouseDiv = true
        this.adminCapmusDiv = false
        let queryHouseByManagerUserPromise = this.queryHouseByManagerUser();
        queryHouseByManagerUserPromise.then(queryHouseByManagerUserRes=>{
          if(queryHouseByManagerUserRes.code==0 && queryHouseByManagerUserRes.data != null && queryHouseByManagerUserRes.data.length > 0)
        {
          this.campusHouseList =queryHouseByManagerUserRes.data;
          let houseOne = this.campusHouseList[0];
          this.param.houseId = houseOne.houseId;
          let getCurrHouseCurrAllFloorBackStatisticListPromise = this.getCurrHouseCurrAllFloorBackStatisticList(houseOne.houseId,houseOne.schoolNum);
          getCurrHouseCurrAllFloorBackStatisticListPromise.then(getCurrHouseCurrAllFloorBackStatisticListRes=>{
            if(getCurrHouseCurrAllFloorBackStatisticListRes.code==0 && getCurrHouseCurrAllFloorBackStatisticListRes.data != null )
          {
            this.schoolBackStatisticList =getCurrHouseCurrAllFloorBackStatisticListRes.data;
            this.checkinDate = this.schoolBackStatisticList[0].checkinDate
            this.backStatisConvert(this.schoolBackStatisticList);
            this.drawPie();
            //this.drawBarCurrCampusAllHouseBackStatis();/////选择校区后的楼栋饼图
            //this.divMoreBar(this.schoolBackStatisticList)
          }
        })

          let getCurrCampusCurrHouseBackStatisticPromise = this.getCurrCampusCurrHouseBackStatistic(houseOne.houseId,houseOne.schoolNum);
          getCurrCampusCurrHouseBackStatisticPromise.then(getCurrCampusCurrHouseBackStatisticRes=>{
            if(getCurrCampusCurrHouseBackStatisticRes.code == 0 && getCurrCampusCurrHouseBackStatisticRes.data != null && getCurrCampusCurrHouseBackStatisticRes.data.length > 0){
          //this.backStatisConvert(this.schoolBackStatisticList);
          this.drawBarSchoolBackStatistics(getCurrCampusCurrHouseBackStatisticRes.data[0]);
        }
        })
        }
      })
      }
    },
    created() {
      let Promise=this.getSchoolarealist();
      Promise.then(res=>{
        if(res.code==0 && res.data != null && res.data.length > 0)
      {
        this.schoolarealist=res.data;
      }
    })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .center {
  .container {
    width: 1200px;
  .titlepanel {
    width: 100%;
    height: 48px;
    background: white;
    line-height: 48px;
    font-size: 16px;
    margin-top: 20px;
    text-indent: 1em;
  }
  .xqul {
    width: 100%;
    /*height: 118px;*/
    margin-top: 20px;
  ul {
    width: 100%;
    height: 100%;
  li {
    height: 100%;
    background: white;
    border-radius: 4px;
    font-size: 20px;
    margin-right: 10px;
    width: 228px;
    float: left;
    text-align: center;
    line-height: 118px;
    transition: .3s;
    cursor: pointer;
  }
  li.active {
    color: #26AEF3;
  }
  li:hover {
    border-radius: 6px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.78);

  }
  }
  }
  .eacharts {
    background: white;
    margin-top: 20px;
  .bars {
    height: 690px;
    widows: 100%;
  .myEchartBar
  {
    margin: auto;
  }
  }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/beddingStatistics/beddingStatistics.vue